/** DOM 取得まわりの型付きヘルパー。null チェックを呼び出し側から追い出す。 */

export function qs<E extends Element = HTMLElement>(
  selector: string,
  scope: ParentNode = document,
): E | null {
  return scope.querySelector<E>(selector)
}

export function qsa<E extends Element = HTMLElement>(
  selector: string,
  scope: ParentNode = document,
): E[] {
  return Array.from(scope.querySelectorAll<E>(selector))
}

/** 必須要素の取得。無ければ例外にせず null を返し、呼び出し側でモジュールごと skip する。 */
export function optional<E extends Element = HTMLElement>(
  selector: string,
  scope: ParentNode = document,
): E | null {
  return qs<E>(selector, scope)
}

/** data 属性を数値として読む。未設定・非数値なら fallback。 */
export function numberAttr(el: Element, name: string, fallback = 0): number {
  const raw = el.getAttribute(name)
  if (raw === null) return fallback
  const value = Number.parseFloat(raw)
  return Number.isFinite(value) ? value : fallback
}

export const prefersReducedMotion = (): boolean =>
  window.matchMedia('(prefers-reduced-motion: reduce)').matches

/** CSS 側のブレークポイント（max-width: 767px）と揃えた SP 判定 */
export const isMobile = (): boolean => window.matchMedia('(max-width: 767px)').matches
